module.exports = require("vue-element-dialog-draggable");